/*
 *
 * DivisionEdit actions
 *
 */

import {
  GET_DIVISION_WATCHER,
  GET_DIVISION_SUCCESS,
  GET_DIVISION_FAILED,
  GET_DIVISION_PARENTS_WATCHER,
  GET_DIVISION_PARENTS_SUCCESS,
  GET_DIVISION_PARENTS_FAILED,
  GET_SUBDIVISIONS_WIHOUT_PARENT_WATCHER,
  GET_SUBDIVISIONS_WIHOUT_PARENT_SUCCESS,
  GET_SUBDIVISIONS_WIHOUT_PARENT_FAILED,
  DELETE_DIVISION_WATCHER,
  DELETE_DIVISION_SUCCESS,
  DELETE_DIVISION_FAILED,
  ADD_SUBDIVISION_WATCHER,
  ADD_SUBDIVISION_SUCCESS,
  ADD_SUBDIVISION_FAILED,
  GET_CHILDREN_DIVISION_WATCHER,
  GET_CHILDREN_DIVISION_SUCCESS,
  GET_CHILDREN_DIVISION_FAILED,
  DELETE_SUBDIVISION_WATCHER,
  DELETE_SUBDIVISION_SUCCESS,
  DELETE_SUBDIVISION_FAILED,
  UPDATE_NAME_DIVISION_WATCHER,
  UPDATE_NAME_DIVISION_SUCCESS,
  UPDATE_NAME_DIVISION_FAILED,
  CHANGE_SELECT_SUPERIOR_WATCHER,
  CHANGE_SELECT_SUPERIOR_SUCCESS,
  CHANGE_SELECT_SUPERIOR_FAILED,
  UP_LEVEL_ONE_WATCHER,
  UP_LEVEL_ONE_SUCCESS,
  UP_LEVEL_ONE_FAILED,
  GET_COLLABORATORS_DIVISION_WATCHER,
  GET_COLLABORATORS_DIVISION_SUCCESS,
  GET_COLLABORATORS_DIVISION_FAILED,
  GET_EMPLOYEES_DIVISIONS_WATCHER,
  GET_EMPLOYEES_DIVISIONS_FAILED,
  GET_EMPLOYEES_DIVISIONS_SUCCESS,
  GET_HISTORY_WATCHER,
  GET_HISTORY_SUCCESS,
  GET_HISTORY_FAILED,
  GET_LANGUAGE_WATCHER,
  GET_LANGUAGE_SUCCESS,
  GET_LANGUAGE_FAILED,
} from "./constants"

// GET LANGAUGE
export function getLanguageWatcher(payload) {
  return {
    type: GET_LANGUAGE_WATCHER,
    payload,
  }
}

export function getLanguageSuccess(payload) {
  return {
    type: GET_LANGUAGE_SUCCESS,
    payload,
  }
}

export function getLanguageFailed(payload) {
  return {
    type: GET_LANGUAGE_FAILED,
    payload,
  }
}
//  GET DIVISION
export function getHistoryWatcher(payload) {
  return {
    type: GET_HISTORY_WATCHER,
    payload,
  }
}

export function getHistorySuccess(payload) {
  return {
    type: GET_HISTORY_SUCCESS,
    payload,
  }
}

export function getHistoryFailed(payload) {
  return {
    type: GET_HISTORY_FAILED,
    payload,
  }
}

// GET DIVISION
export function getDivisionWatcher(payload) {
  return {
    type: GET_DIVISION_WATCHER,
    payload,
  }
}

export function getDivisionSuccess(payload) {
  return {
    type: GET_DIVISION_SUCCESS,
    payload,
  }
}

export function getDivisionFailed(payload) {
  return {
    type: GET_DIVISION_FAILED,
    payload,
  }
}

// GET CHILDREN DIVISION
export function getChildrenDivisionWatcher(payload) {
  return {
    type: GET_CHILDREN_DIVISION_WATCHER,
    payload,
  }
}

export function getChildrenDivisionSuccess(payload) {
  return {
    type: GET_CHILDREN_DIVISION_SUCCESS,
    payload,
  }
}

export function getChildrenDivisionFailed(payload) {
  return {
    type: GET_CHILDREN_DIVISION_FAILED,
    payload,
  }
}

// GET DIVISION PARENTS
export function getDivisionParentsWatcher(payload) {
  return {
    type: GET_DIVISION_PARENTS_WATCHER,
    payload,
  }
}

export function getDivisionParentsSuccess(payload) {
  return {
    type: GET_DIVISION_PARENTS_SUCCESS,
    payload,
  }
}

export function getDivisionParentsFailed(payload) {
  return {
    type: GET_DIVISION_PARENTS_FAILED,
    payload,
  }
}

// GET SUBDIVISIONS WITHOUT PARENTS
export function getSubdivisionsWithoutParentWatcher(payload) {
  return {
    type: GET_SUBDIVISIONS_WIHOUT_PARENT_WATCHER,
    payload,
  }
}

export function getSubdivisionsWithoutParentSuccess(payload) {
  return {
    type: GET_SUBDIVISIONS_WIHOUT_PARENT_SUCCESS,
    payload,
  }
}

export function getSubdivisionsWithoutParentFailed(payload) {
  return {
    type: GET_SUBDIVISIONS_WIHOUT_PARENT_FAILED,
    payload,
  }
}

// DELETE DIVISION
export function deleteDivisionWatcher(payload) {
  return {
    type: DELETE_DIVISION_WATCHER,
    payload,
  }
}

export function deleteDivisionSuccess(payload) {
  return {
    type: DELETE_DIVISION_SUCCESS,
    payload,
  }
}

export function deleteDivisionFailed(payload) {
  return {
    type: DELETE_DIVISION_FAILED,
    payload,
  }
}

// ADD SUBDIVISION
export function addSubdivisionWatcher(payload) {
  return {
    type: ADD_SUBDIVISION_WATCHER,
    payload,
  }
}

export function addSubdivisionSuccess(payload) {
  return {
    type: ADD_SUBDIVISION_SUCCESS,
    payload,
  }
}

export function addSubdivisionFailed(payload) {
  return {
    type: ADD_SUBDIVISION_FAILED,
    payload,
  }
}

// DELETE SUBDIVISION
export function deleteSubdivisionWatcher(payload) {
  return {
    type: DELETE_SUBDIVISION_WATCHER,
    payload,
  }
}

export function deleteSubdivisionSuccess(payload) {
  return {
    type: DELETE_SUBDIVISION_SUCCESS,
    payload,
  }
}

export function deleteSubdivisionFailed(payload) {
  return {
    type: DELETE_SUBDIVISION_FAILED,
    payload,
  }
}

// UPDATE DIVISION
export function updateNameDivisionWatcher(payload) {
  return {
    type: UPDATE_NAME_DIVISION_WATCHER,
    payload,
  }
}

export function updateNameDivisionSuccess(payload) {
  return {
    type: UPDATE_NAME_DIVISION_SUCCESS,
    payload,
  }
}

export function updateNameDivisionFailed(payload) {
  return {
    type: UPDATE_NAME_DIVISION_FAILED,
    payload,
  }
}

// CHANGE SELECT SUPERIOR
export function changeSelectSuperiorWatcher(payload) {
  return {
    type: CHANGE_SELECT_SUPERIOR_WATCHER,
    payload,
  }
}

export function changeSelectSuperiorSuccess(payload) {
  return {
    type: CHANGE_SELECT_SUPERIOR_SUCCESS,
    payload,
  }
}

export function changeSelectSuperiorFailed(payload) {
  return {
    type: CHANGE_SELECT_SUPERIOR_FAILED,
    payload,
  }
}

// CHANGE SELECT SUPERIOR
export function upLevelOneWatcher(payload) {
  return {
    type: UP_LEVEL_ONE_WATCHER,
    payload,
  }
}

export function upLevelOneSuccess(payload) {
  return {
    type: UP_LEVEL_ONE_SUCCESS,
    payload,
  }
}

export function upLevelOneFailed(payload) {
  return {
    type: UP_LEVEL_ONE_FAILED,
    payload,
  }
}

// GET COLLABORATORS FOR DIVISION
export function getCollaboratorsDivisionWatcher(payload) {
  return {
    type: GET_COLLABORATORS_DIVISION_WATCHER,
    payload,
  }
}

export function getCollaboratorsDivisionSuccess(payload) {
  return {
    type: GET_COLLABORATORS_DIVISION_SUCCESS,
    payload,
  }
}

export function getCollaboratorsDivisionFailed(payload) {
  return {
    type: GET_COLLABORATORS_DIVISION_FAILED,
    payload,
  }
}

export function getEmployeesDivisionsWatcher(payload) {
  return {
    type: GET_EMPLOYEES_DIVISIONS_WATCHER,
    payload,
  }
}

export function getEmployeesDivisionsSuccess(payload) {
  return {
    type: GET_EMPLOYEES_DIVISIONS_SUCCESS,
    payload,
  }
}

export function getEmployeesDivisionsFailed(payload) {
  return {
    type: GET_EMPLOYEES_DIVISIONS_FAILED,
    payload,
  }
}
